import { Grid, styled } from "@mui/material";

const FullScreenGridItem = styled((props) => (
  <Grid item xs={12} sm={6} {...props} />
))(() => ({}));

export default FullScreenGridItem;
